// router.js
import { createRouter, createWebHistory } from 'vue-router';

import DashboardScreen from './pages/DashboardScreen.vue';
import DashboardScreen1 from './pages/DashboardScreen1.vue';
import DashboardScreen2 from './pages/DashboardScreen2.vue';
import DashboardScreen3 from './pages/DashboardScreen3.vue';
import LoginScreen from './pages/LoginScreen.vue';
import IntelligenceScreen from './pages/IntelligenceScreen.vue';
import GrowthScreen from './pages/GrowthScreen.vue';
import VaultScreen from './pages/VaultScreen.vue';
import SignupScreen from './pages/SignupScreen.vue';
import ForgotScreen from './pages/ForgotScreen.vue';
import Campaigns from "./pages/Campaigns.vue";
import CampaignsDetails from "./pages/CampaignsDetails.vue";
import OurPlans from "./pages/OurPlans.vue";

import AdminCreators from './pages/AdminCreators.vue';
import AdminCreatorDetail from './pages/AdminCreatorDetail.vue';
import AdminAudienceMetrics from './pages/AdminAudienceMetrics.vue';
import AdminBroadcastMonitor from './pages/AdminBroadcastMonitor.vue';
import AdminAuditLogs from './pages/AdminAuditLogs.vue';
import AdminPlans from './pages/AdminPlans.vue';
import AdminSettings from './pages/AdminSettings.vue';
import AdminProfile from './pages/AdminProfile.vue';
import AdminAccessDenied from './pages/AdminAccessDenied.vue';

import FollowingScreen from "./pages/Following.vue";
import FanContentScreen from "./pages/FanContent.vue";
import SettingsScreen from "./pages/Settings.vue";

import AgencyDiscover from "./pages/DiscoverInfluencers.vue";
import AgencyInfluencerDetails from "./pages/AgencyInfluencerDetails.vue";
import AgencyInfluencerCompare from "./pages/AgencyInfluencerCompare.vue";
import AgencyShortlist from "./pages/Shortlist.vue";
import AgencyInsights from "./pages/Insights.vue";
import AgencySettings from "./pages/AgencySettings.vue";
import AgencyCampaigns from "./pages/AgencyCampaigns.vue";
import AgencyCampaignsNew from "./pages/AgencyCampaignsNew.vue";
import AgencyCampaignsDetails from "./pages/AgencyCampaignsDetails.vue";


import NotificationAc from "./pages/NotificationAc.vue";
import JoinComp from "./pages/JoinComp.vue";
import InfDetails from "./pages/InfDetails.vue";
// InfDetails


const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardScreen
  },
  {
    path: "/agency/discover",
    name: "AgencyDiscover",
    component: AgencyDiscover,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
      path: "/join/:influencer_id",
      name: "JoinComp",
      component: JoinComp
    }
    ,
  {
    path: "/agency/interested",
    name: "AgencyInterested",
    component: AgencyShortlist,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
   {
    path: "/agency/influencer-profile/:infId",
    name: "AgencyInfluencerProfile",
    component: AgencyInfluencerDetails,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: "/agency/influencer-compare",
    name: "AgencyInfluencerCompare",
    component: AgencyInfluencerCompare,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: "/agency/insights",
    name: "AgencyInsights",
    component: AgencyInsights,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
   {
    path: "/agency/campaigns",
    name: "AgencyCampaigns",
    component: AgencyCampaigns,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
   {
    path: "/agency/campaigns/new",
    name: "AgencyCampaignsNew",
    component: AgencyCampaignsNew,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: "/agency/campaigns/details/:campId",
    name: "AgencyCampaignsDetails",
    component: AgencyCampaignsDetails,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: "/agency/settings",
    name: "AgencySettings",
    component: AgencySettings,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: "/notifications",
    name: "notifications",
    component: NotificationAc,
    meta: {
      requiresAuth: true,
      role: "agency"
    }
  },
  {
    path: '/home1',
    name: 'Home1',
    component: DashboardScreen1
  },
  {
    path: '/home3',
    name: 'Home3',
    component: DashboardScreen3
  },
  { path: "/user/following",
    name: "UserFollowing",
    component: FollowingScreen
  },
  {
    path: "/user/content",
    name: "UserContent",
    component: FanContentScreen
  },
  {
    path: "/user/settings",
    name: "UserSettings",
    component: SettingsScreen
  },
  {
    path: '/home2',
    name: 'Home2',
    component: DashboardScreen2
  },
  {
    path: '/login',
    name: 'login_screen',
    component: LoginScreen
  },
  {
    path: '/signup',
    name: 'signup_screen',
    component: SignupScreen
  },
   {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotScreen
  },
  {
    path: '/audience',
    name: 'audience',
    component: IntelligenceScreen
  },
  {
    path: '/settings',
    name: 'settings',
    component: GrowthScreen
  },
  {
    path: '/campaigns',
    name: 'CampaignsAc',
    component: Campaigns
  },
  {
    path: '/campaigns-details/:campId',
    name: 'CampaignsAcDt',
    component: CampaignsDetails
  },
  {
    path: '/our-plans',
    name: 'OurPlans',
    component: OurPlans
  },
  {
    path: '/send-broadcast',
    name: 'send_broadcast',
    component: VaultScreen
  },
  {
    path: '/admin/creators',
    name: 'admin-creators',
    component: AdminCreators
  },

  {
    path: '/admin/creators/:id',
    name: 'admin-creator-detail',
    component: AdminCreatorDetail
  },

  {
    path: '/admin/audience',
    name: 'admin-audience',
    component: AdminAudienceMetrics
  },
   {
    path: '/influencer/:infId',
    name: 'influencer-dt',
    component: InfDetails
  },

  {
    path: '/admin/broadcasts',
    name: 'admin-broadcast-monitor',
    component: AdminBroadcastMonitor
  },

  {
    path: '/admin/logs',
    name: 'admin-audit-logs',
    component: AdminAuditLogs
  },

  {
    path: '/admin/plans',
    name: 'admin-plans',
    component: AdminPlans
  },

  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: AdminSettings
  },

  {
    path: '/admin/profile',
    name: 'admin-profile',
    component: AdminProfile
  },

  {
    path: '/admin/access-denied',
    name: 'admin-access-denied',
    component: AdminAccessDenied
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
  
  if (
    to.path.includes("join")
  ) {
    return next();
  }

  if (
    to.path.includes("signup") ||
    to.path.includes("forgot-password")
  ) {
    if(!ldata){
      return next();
    }
  }
  if (!to.path.includes("login") && !ldata) {
  
    window.location.href = "/login";
  }

  if (
  (
    to.path.includes("login") ||
    to.path.includes("signup") ||
    to.path.includes("forgot-password")
  ) && ldata) {
    if (ldata.user_type === "admin") return next("/home1");
    else if (ldata.user_type === "audience") return next("/home2");
    else if (ldata.user_type === "agancy") return next("/home3");
    return next("/");
  }

  if (to.path === "/home" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }
  if (to.path === "/home2" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }
  if (to.path === "/home3" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }
  if (to.path === "/home" && ldata && ldata.user_type === "audience") {
    return next("/home2");
  }
  if (to.path === "/home1" && ldata && ldata.user_type === "audience") {
    return next("/home2");
  }
  if (to.path === "/home3" && ldata && ldata.user_type === "audience") {
    return next("/home2");
  }

   if (to.path === "/home" && ldata && ldata.user_type === "agancy") {
    return next("/home3");
  }
  if (to.path === "/home1" && ldata && ldata.user_type === "agancy") {
    return next("/home3");
  }
  if (to.path === "/home2" && ldata && ldata.user_type === "agancy") {
    return next("/home3");
  }

  if (to.path === "/" && ldata && ldata.user_type === "admin") {
    return next("/home1");
  }

  if (to.path === "/" && ldata && ldata.user_type === "audience") {
    return next("/home2");
  }
  if (to.path === "/" && ldata && ldata.user_type === "agancy") {
    return next("/home3");
  }

  if (to.path === "/home1" && ldata && ldata.user_type === "influencer") {
    return next("/");
  }

  next();
});



export default router;
